exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background .title span {\n  display: inline;\n  font-family: 'TTNorms Bold', sans-serif;\n}\n", ""]);

// exports
